import { call, put, takeEvery } from 'redux-saga/effects'

import { types } from '../../types'
import { getAllMusicOnHold } from '../apiRequests/commonRequests'
import { getNotificationCount } from '../apiRequests/notificationRequest'
import { getBankGatewaysRequest, getCurrentCustomerCreditAmount, getMinimumAmountRequest, getVatPercentRequest, postMakeChargeRequest, prepareForGatewayToMakeChargeRequest } from '../apiRequests/chargeRequests'





function* handlePostMakeChargeRequest(action) {
    try {

        const response = yield call(postMakeChargeRequest, action.params)
        yield put({
            type: types.POST_MAKE_CHARGE_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.POST_MAKE_CHARGE_ERROR,
            error: error.response,
        })
    }
}

function* handleGetBankGatewaysRequest() {
    try {
        const response = yield call(getBankGatewaysRequest)
        yield put({
            type: types.GET_BANK_GATEWAYS_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_BANK_GATEWAYS_ERROR,
            error: error.response,
        })
    }
}

function* handleGetMinimumAmountRequest() {
    try {
        const response = yield call(getMinimumAmountRequest)
        yield put({
            type: types.GET_MINIMUM_CHARGE_AMOUNT_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_MINIMUM_CHARGE_AMOUNT_ERROR,
            error: error.response,
        })
    }
}


function* handleGetVatPercentRequest() {
    try {
        const response = yield call(getVatPercentRequest)
        yield put({
            type: types.GET_VAT_PERCENT_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_VAT_PERCENT_ERROR,
            error: error.response,
        })
    }
}


function* handleGetCurrentChargeRequest() {
    try {
        const response = yield call(getCurrentCustomerCreditAmount)
        yield put({
            type: types.GET_CURRENT_CHARGE_AMOUNT_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.GET_CURRENT_CHARGE_AMOUNT_ERROR,
            error: error.response,
        })
    }
}


function* handlePrepareForGatewayToMakeChargeRequest(action) {
    try {
        const response = yield call(prepareForGatewayToMakeChargeRequest, action.params)
        yield put({
            type: types.PREPARE_FOR_GATEWAY_TO_MAKE_CHARGE_SUCCESS,
            action: response,
        })
    } catch (error) {
        yield put({
            type: types.PREPARE_FOR_GATEWAY_TO_MAKE_CHARGE_ERROR,
            error: error.response,
        })
    }
}


function* watcherChargeSaga() {
    yield takeEvery(types.GET_BANK_GATEWAYS_REQUEST, handleGetBankGatewaysRequest)
    yield takeEvery(types.GET_MINIMUM_CHARGE_AMOUNT_REQUEST, handleGetMinimumAmountRequest)
    yield takeEvery(types.GET_VAT_PERCENT_REQUEST, handleGetVatPercentRequest)
    yield takeEvery(types.POST_MAKE_CHARGE_REQUEST, handlePostMakeChargeRequest)
    yield takeEvery(types.GET_CURRENT_CHARGE_AMOUNT_REQUEST, handleGetCurrentChargeRequest)
    yield takeEvery(types.PREPARE_FOR_GATEWAY_TO_MAKE_CHARGE_REQUEST, handlePrepareForGatewayToMakeChargeRequest)



}

export default watcherChargeSaga
